<template>
  <form
    class="form form--login"
    method="post"
    @submit.prevent="submit"
    ref="form"
  >
    <div :class="formItemClasses('user')">
      <input
        class="form-element form--login__user"
        type="text"
        name="user"
        :placeholder="str('login.user')"
        v-model="user"
        autofocus
      />
    </div>
    <div :class="formItemClasses('password')">
      <input
        class="form-element form--login__pwd"
        type="password"
        name="pwd"
        :placeholder="str('login.password')"
        v-model="pwd"
      />
    </div>
    <div class="form-errors">
      {{ formError }}
      <div class="form-errors-reset" v-if="formError">
        Haben Sie Ihr
        <router-link class="pw-reset" to="/passwort-zuruecksetzen">
          Passwort vergessen?
        </router-link>
      </div>
    </div>
    <div class="form-actions">
      <LinkButton icon-right="Arrow" form="login" :text="str('login.submit')" />
    </div>

    <router-link class="form--login__pw-reset" to="/passwort-zuruecksetzen">
      Passwort vergessen?
    </router-link>
  </form>
</template>

<script>
  import LinkButton from '@/components/LinkButton'

  export default {
    name: 'form-login',
    data: () => {
      return {
        user: '',
        pwd: '',
        focusedFormItem: '',
      }
    },
    components: {
      LinkButton,
    },
    computed: {
      formError: function () {
        return this.$store.getters.authenticationErrorMessage
      },
    },
    methods: {
      formItemClasses: function (id) {
        let classes = ['form-item']
        if (this.focusedFormItem && this.focusedFormItem === id) {
          classes.push('form-item--focused')
        }
        return classes.join(' ')
      },
      submit() {
        if (this.user.length < 5 || this.pwd.length < 5) {
          this.$store.commit(
            'userAuthenticationFailed',
            this.str('authentication.provideUserNameAndPassword')
          )
          return
        } else {
          this.error = null
        }

        this.$store.dispatch('authenticateUser', {
          user: this.user,
          pwd: this.pwd,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .form--login {
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    transition: $transition-base;

    @media (min-height: 360px) {
      margin-top: 8vh;
    }

    @media (min-height: 400px) {
      margin-top: 20vh;
    }

    &__pw-reset {
      margin-top: spacer(1);
      display: inline-block;
      cursor: pointer;

      @media (min-height: 400px) {
        margin-top: spacer(2);
      }
    }
  }

  .pw-reset {
    cursor: pointer;
    color: $community;

    @include hover-focus-active {
      color: darken($community, 5%);
    }
  }
</style>
